import { render, staticRenderFns } from "./uploadOrAutogenerateFileToProyectPlataform.vue?vue&type=template&id=0f13771f"
import script from "./uploadOrAutogenerateFileToProyectPlataform.vue?vue&type=script&lang=js"
export * from "./uploadOrAutogenerateFileToProyectPlataform.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports